import { Component } from '@angular/core';

import { ILoadingCellRendererAngularComp } from 'ag-grid-angular';
import { ILoadingCellRendererParams } from 'ag-grid-community';

import { LoaderComponent } from '@camelot/ui';

@Component({
  selector: 'cam-ag-grid-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  imports: [LoaderComponent],
})
export class LoadingComponent implements ILoadingCellRendererAngularComp {
  public params!: ILoadingCellRendererParams;

  agInit(params: ILoadingCellRendererParams): void {
    this.params = params;
  }
}
